export default "__VITE_ASSET__67dc8403__"